import { RefreshCw } from "lucide-react";
import React, { useLayoutEffect, useState } from "react";

import { hardReload as defaultReload } from "@/lib/hard-reload";
import { cn } from "@/lib/utils";

/** Высота плашки (`h-7`); та же величина уходит в `--app-banner-h`, на которую
 * ужимаются скан-экраны (`.h-app`) и фиксированные части `Layout`. */
const BANNER_HEIGHT = "1.75rem";

/** Узкая полоса «Вышла новая версия портала» в потоке над страницей: ничего
 * не перекрывает, крестика нет — уходит только с перезагрузкой. Пока видна,
 * держит на `<html>` переменную `--app-banner-h`, чтобы экраны на весь
 * вьюпорт стали ниже на её высоту, а не уехали за край. */
export function UpdateBanner({
  className,
  onReload = defaultReload,
}: {
  className?: string;
  onReload?: () => void | Promise<void>;
}): React.ReactElement {
  const [busy, setBusy] = useState(false);

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--app-banner-h", BANNER_HEIGHT);
    return () => {
      root.style.removeProperty("--app-banner-h");
    };
  }, []);

  return (
    <div
      role="status"
      className={cn(
        "flex h-7 shrink-0 items-center gap-2 overflow-hidden",
        "bg-amber-300 px-3 text-xs text-amber-950",
        className,
      )}
    >
      {/* На ТСД (360 px) полная фраза резалась посреди слова — там короткая,
          что делать, и так говорит кнопка рядом. */}
      <span className="min-w-0 flex-1 truncate sm:hidden">Новая версия портала</span>
      <span className="hidden min-w-0 flex-1 truncate sm:inline">
        Вышла новая версия портала — обновите страницу
      </span>
      <button
        type="button"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          void onReload();
        }}
        className="inline-flex shrink-0 items-center gap-1 rounded bg-amber-950 px-2 py-0.5 font-medium text-amber-50 hover:bg-amber-900 disabled:opacity-60"
      >
        <RefreshCw className={busy ? "size-3 animate-spin" : "size-3"} />
        Обновить
      </button>
    </div>
  );
}
